import { useState } from "react";

type Props = {
  label: string;
  value: React.ReactNode | string | number | null | undefined;
  copy?: boolean;
  copyValue?: string;
  mono?: boolean;
};

const isEmpty = (v: unknown): boolean =>
  v === null ||
  v === undefined ||
  (typeof v === "string" && v.trim() === "");

export default function Field({
  label,
  value,
  copy = false,
  copyValue,
  mono = false,
}: Props) {
  const [copied, setCopied] = useState(false);
  const empty = isEmpty(value);

  const handleCopy = async () => {
    const v = copyValue ?? (typeof value === "string" ? value : String(value ?? ""));
    if (!v) return;
    try {
      await navigator.clipboard.writeText(v);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      // clipboard blocked
    }
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "0.75rem",
        padding: "0.4rem 0",
        borderTop: "1px dashed #f1f3f5",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          width: "30%",
          minWidth: 140,
          fontSize: ".75rem",
          color: "#73879C",
          textTransform: "uppercase",
          letterSpacing: ".3px",
          fontWeight: 600,
          paddingTop: "0.1rem",
        }}
      >
        {label}
      </div>
      <div
        style={{
          flex: 1,
          minWidth: 0,
          fontSize: ".88rem",
          color: empty ? "#adb5bd" : "#1f2933",
          fontFamily: mono ? "monospace" : "inherit",
          wordBreak: "break-word",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <span>{empty ? "—" : value}</span>
        {copy && !empty && (
          <button
            type="button"
            onClick={handleCopy}
            title="Copiar"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0.15rem 0.4rem",
              borderRadius: "0.3rem",
              background: copied ? "#1a7f37" : "#f8f9fb",
              color: copied ? "white" : "#73879C",
              border: "1px solid #dee2e6",
              fontSize: ".7rem",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            {copied ? "✓" : "copy"}
          </button>
        )}
      </div>
    </div>
  );
}

export function FieldGrid({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
        columnGap: "1.5rem",
      }}
    >
      {children}
    </div>
  );
}
